import styles from '../styles/Services.module.css';
import pickerl from '../assets/pickerl.png'; 
import motorcycle from '../assets/motorcycle.png'; 
import repair from '../assets/wrench-tool.png';

const Services = () => {
    const services = [
        { title: '§57a-Prüfung', image: pickerl, description: 'Die §57a Überprüfung, auch bekannt als „Pickerl“, ist die gesetzlich vorgeschriebene Fahrzeugprüfung zur Sicherstellung der Verkehrssicherheit und Umweltverträglichkeit. Ich führe die Prüfung schnell und zuverlässig durch, damit Ihr Fahrzeug den gesetzlichen Anforderungen entspricht und Sie sicher unterwegs sind. Vereinbaren Sie jetzt einen Termin bei mir!' },
        { title: 'Umbauten mit Schwerpunkt auf Krafträder', image: motorcycle, description: 'Möchten Sie Ihr Motorrad ganz nach Ihren Vorstellungen gestalten? Ob Chopper-Umbau, Leistungsoptimierung oder individuelle Designänderungen – ich realisiere maßgeschneiderte Umbauten für Ihr Bike. Mit Erfahrung und Leidenschaft sorge ich dafür, dass Ihr Motorrad-Traum wahr wird.' },
        { title: 'Reparaturen', image: repair, cssAdaption: true, description: 'Als erfahrener Mechaniker übernehme ich alle Reparaturen an Ihrem Motorrad schnell und fachgerecht. Egal ob Motor, Bremsen oder Elektrik – mit Sorgfalt und Know-how bringe ich Ihr Fahrzeug wieder in Top-Zustand.' }
    ];

    return (
        <section className={styles.services} id="services">
            <h1>Dienstleistungen</h1>
            <div className={styles.grid}>
                {services.map((service, index) => {

                    const imageOverlay = service.cssAdaption ? `${styles.imageOverlay} ${styles.cssAdaption}` : styles.imageOverlay;
                    return (
                    <div key={index} className={styles.card}>
                            <div className={styles.picture}>
                                <div className={`${imageOverlay}`}>
                                <img src={service.image} alt={service.title} />
                            </div>
                        </div>
                        <h2>{service.title}</h2>
                        <p>{service.description}</p>
                    </div>);
                })}
            </div>
        </section>
    );
};

export default Services;
